import React from 'react';

import { DAYTIME_SERVICES } from '@rover/constants/src/translations/service.constants';
import { Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

const CIRCLE_SIZE = 32;
const ICON_SIZE = 24;

type Props = {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  testID?: string;
  serviceSlug?: string;
  backgroundColor?: string;
  iconColor?: string;
};

const ServiceIconBadge = ({
  icon: IconComponent,
  testID,
  serviceSlug,
  backgroundColor,
  iconColor,
}: Props): JSX.Element => {
  const theme = useTheme();
  // Daytime services carry the orange palette; everything else stays on the blue one.
  const isDaytime = (DAYTIME_SERVICES as string[]).includes(serviceSlug ?? '');
  const defaultBackgroundColor = isDaytime ? theme.colors.orange[200] : theme.colors.blue[200];
  const defaultIconColor = isDaytime ? theme.colors.orange[700] : theme.colors.blue[800];

  return (
    <Flex
      data-testid={testID}
      flexShrink="0"
      alignItems="center"
      justifyContent="center"
      borderRadius="50%"
      width={CIRCLE_SIZE}
      height={CIRCLE_SIZE}
      backgroundColor={backgroundColor ?? defaultBackgroundColor.toString()}
      aria-hidden="true"
    >
      <IconComponent
        width={ICON_SIZE}
        height={ICON_SIZE}
        fill={iconColor ?? defaultIconColor.toString()}
        aria-hidden="true"
      />
    </Flex>
  );
};

export default ServiceIconBadge;
